<template>
  <div data-v-249f9abc="" class="wrapper clearfix">
    <div data-v-1dc60391="" data-v-249f9abc="" class="content clearfix">
      <div data-v-1dc60391="" class="main">
        <div data-v-064cc9e2="" data-v-1dc60391="">
          <h1 data-v-064cc9e2="">
            水表移装、扩径
          </h1>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="个人" name="first">
              <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
          <el-form-item label="联系人：" prop="name" class="cl_one">
              <el-input
                v-model="ruleForm.name"
                class="jianwidth"
                placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="num">
              <el-input
                v-model="ruleForm.num"
                class="jianwidth"
                placeholder="请输入联系人电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="地址：" prop="dizhi">
              <el-input
                v-model="ruleForm.dizhi"
                class="jianwidth"
                placeholder="请输入地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号：" prop="ID_number">
              <el-input
                v-model="ruleForm.ID_number"
                class="jianwidth"
                placeholder="请输入身份证号"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" :plain="true" @click="submitForm('ruleForm')">提交</el-button>
              <!-- <el-button type="primary" @click="submitForm('ruleForm')"
                >提交</el-button
              > -->
            </el-form-item>
          </el-form>
            </el-tab-pane>
            <el-tab-pane label="企业" name="second" >
              <el-form
                :model="ruleForm_qi"
                :rules="rulesly"
                ref="ruleForm"
                label-width="180px"
                class="demo-ruleForm"
              >
              <el-form-item label="营业执照：" prop="zjzm_qi" class="cl_one">
                  <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" />
                  </el-dialog>
                </el-form-item>
                <el-form-item label="联系人：" prop="jingbani_qi">
                  <el-input
                    v-model="ruleForm.jingbani_qi"
                    class="jianwidth"
                    placeholder="请输入联系人"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系电话：" prop="jblxfs_qi">
                  <el-input
                    v-model="ruleForm.jblxfs_qi"
                    class="jianwidth"
                    placeholder="请输入联系电话"
                  ></el-input>
                </el-form-item>
                <el-form-item label="户号：" prop="name_qi" class="cl_one">
                  <el-input
                    v-model="ruleForm.name_qi"
                    class="jianwidth"
                    placeholder="请输入户号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="地址：" prop="address">
                  <el-input
                    v-model="ruleForm.address"
                    class="jianwidth"
                    placeholder="请输入地址"
                  ></el-input>
                </el-form-item>
                
                <!-- <el-form-item label="产权证明" prop="chanquan_qi" class="jiakuan">
                  <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" />
                  </el-dialog>
                </el-form-item> -->
                <!-- <el-form-item label="单位名称" prop="num_qi">
                  <el-input
                    v-model="ruleForm.num_qi"
                    class="jianwidth"
                    placeholder="请输入单位全称"
                  ></el-input>
                </el-form-item> -->
                
                <!-- <el-form-item label="证件号码" prop="sfzhnum_qi">
                  <el-input
                    v-model="ruleForm.sfzhnum_qi"
                    class="jianwidth"
                    placeholder="请输入证件号码"
                  ></el-input>
                </el-form-item> -->
                
                <el-form-item>
                  <el-button type="primary" :plain="true" @click="submitForm('ruleForm')">提交</el-button>
                  <!-- <el-button type="primary" @click="submitForm('ruleForm')"
                    >提交</el-button
                  > -->
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
          

          <!-- <h2 style="display: flex;justify-content: space-between"><span>请输入需要变更的客户编号</span><span style="color: #064A93">不记得编号？</span></h2>
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="20px" class="demo-ruleForm">
                        <el-form-item  prop="name">
                            <el-input v-model="ruleForm.name" placeholder="10位客户编号"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input type="textarea" v-model="ruleForm.region" placeholder="客户名称"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input style="width: 280px" v-model="ruleForm.yanzh" placeholder="验证码"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
                        </el-form-item>
                    </el-form> -->
        </div>
      </div>
      <businessAside />
    </div>
  </div>
</template>

<script>
import businessAside from "../../components/aside";
export default {
  data() {
    return {
      activeName: "first",
      fileList: "",
      textarea: "",
      value1: "",
      ruleForm: {
        ID_number:'',
        name: "",
        num: "",
        dizhi: "",
        region1: "",
        region2: "",
        region3: "",
        miaoshu: "",
        value: "",
        resource: "",
      },
      ruleForm_qi: {
        frontOfIDCard:'',//身份证正面
        backOfIDCard: "",//身份证反面
        frontOfIDCard_jb:'',//身份证正面
        backOfIDCard_jb: "",//身份证反面
        name_qi:'',
        num_qi:'',
        jingbani_qi:'',
        jblxfs_qi:'',
        sfzhnum_qi:'',
        zjzm_qi:'',
        zjfm_qi:'',
        chanquan_qi:'',
        address:'',
      },
      rules: {
        ID_number: [
          { required: true, message: "请输入身份证号", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        num: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
          { min: 11, max: 11, message: "11位字符", trigger: "blur" },
        ],
        miaoshu: [
          { required: true, message: "请简要叙述变更原因", trigger: "change" },
        ],
        region1: [
          { required: true, message: "请选择问题类型", trigger: "change" },
        ],
        region2: [
          { required: true, message: "请选择所在区域", trigger: "change" },
        ],
        region3: [
          { required: true, message: "请选择所在区域", trigger: "change" },
        ],
        dizhi: [
          { required: true, message: "请输入地址", trigger: "change" },
        ],
        shenfenzheng: [
          { required: true, message: "请输入身份证号", trigger: "change" },
        ],
      },
      rulesly: {
        name_qi: [{ required: true, message: "请输入户号", trigger: "blur" }],
        num_qi: [{ required: true, message: "请输入单位全称", trigger: "blur" }],
        jingbani_qi: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        jblxfs_qi: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { min: 11, max: 11, message: "11位字符", trigger: "blur" },
        ],
        sfzhnum_qi:[
          { required: true, message: "请输入身份证号", trigger: "change" },
        ],
        chanquan_qi: [
          { required: true, message: "请上传产权证明", trigger: "change" },
        ],
        address: [
          { required: true, message: "请输入地址", trigger: "change" },
        ],
        zjzm_qi: [
          {
            required: true,
            message: "请上传原单位营业执照",
            trigger: "change",
          },
        ],
        zjfm_qi: [
          {
            required: true,
            message: "请上传现单位营业执照",
            trigger: "change",
          },
        ],
        frontOfIDCard: [
            { required: true, message: '请上传身份证有人像的一面', trigger: 'change' }
        ],
        backOfIDCard: [
          { required: true, message: '请上传身份证有国徽的一面', trigger: 'change' }
        ],
        frontOfIDCard_jb: [
            { required: true, message: '请上传身份证有人像的一面', trigger: 'change' }
        ],
        backOfIDCard_jb: [
          { required: true, message: '请上传身份证有国徽的一面', trigger: 'change' }
        ],
      },
      // ruleForm: {
      //     name: '',
      //     region: '',
      //     yanzh:''
      // },
      // rules: {
      //     name: [
      //         { required: true, message: '请输入10位客户编号', trigger: 'blur' },
      //         { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
      //     ],
      //     region: [
      //         { required: true, message: '请选择活动区域', trigger: 'change' }
      //     ],
      // }
    };
  },
  watch: {
    // subType(n) {
    //     if ([0, 1, 2].indexOf(n) !== -1) {
    //         this.disabled = false
    //     } else {
    //         this.disabled = true
    //     }
    //     console.log(this.disabled)
    // },
    // isOk(n) {
    //     if (n) {
    //         this.disabled = false
    //     } else {
    //         this.disabled = true
    //     }
    //     console.log(this.disabled)
    // },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    submitForm() {
      this.$message({
          message: '提交成功,请勿重复此操作!',
          type: 'success'
        });
    },
    // submitForm(formName) {
    //     this.$refs[formName].validate((valid) => {
    //         if (valid) {
    //             alert('submit!');
    //         } else {
    //             console.log('error submit!!');
    //             return false;
    //         }
    //     });
    // },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // toRegret() {
    //     const BASE_PATH = window.location.href.split('#')[0]
    //     window.location.href = BASE_PATH + '#' + '/regret_pe'
    // },
  },
  components: {
    businessAside,
  },
};
</script>

<style scoped>
h2 {
  color: #8f8f8f;
  padding: 20px;
}
</style>
